import { InjectionToken } from '@angular/core';

export const PRODUCTION = new InjectionToken<boolean>('Production or Development build');
export const DEMO = new InjectionToken<boolean>('Demo build or not');
